import React, { useEffect } from 'react'
import slugify from 'slugify'

import Hero from '../hero/hero'
import Faq from '../contact/faq'
import FormSection from '../contact/formSection'

import AnchorsContent from '../anchorsContent'

import GetOffsetEl from '../../utils/getOffsetEl'

const ContactLayout = ({data, currentUrl, searchQuery}) => {
  const formTitle = (data.formTitle.formTitle) ? data.formTitle.formTitle : data.formTitle
  
  useEffect(() => {
    if ((searchQuery !== '' && searchQuery !== undefined)) {
      const contactSuccess = document.querySelector('.contact-success')

      if (contactSuccess) {
        const subject = localStorage.getItem('contactSubject')

        if (subject) {
          setTimeout(() => {
            /* eslint-disable-next-line */
            dataLayer.push({
              'event': 'formSubmit',
              'form_type': subject
            })
          }, 800)

          localStorage.removeItem('contactSubject')
        }

        setTimeout(() => {
          window.scrollTo({
            top: GetOffsetEl(contactSuccess)
          })
        }, 300)
      }
    }
  })

  return (
    <div className="w-full">
      <Hero 
        currentUrl={currentUrl}
        data={data}
        type="contact" />

      { data.faqTitle ?
        <AnchorsContent sections={[data.faqTitle, formTitle]}>
          {/* strat 1 */}
          <div className="slice" data-anchor={data.faqTitle} id={`${slugify(data.faqTitle, {remove: /[*+~.,()'"!?:@,]/g}).toLocaleLowerCase()}`}>
            <Faq data={data} />
          </div>

          {/* strat 2 */}
          <FormSection data={data} searchQuery={searchQuery} />
        </AnchorsContent>
        : <>
            <FormSection data={data} searchQuery={searchQuery} />
          </>
      }
    </div>
  )
}

export default ContactLayout